const COOKIE_NAME = 'mhj-recent-searches'
const MAX_RECENT_SEARCHES = 5

// The cookie is client-controlled, so coerce whatever we get to a clean string[] to avoid type error crashes.
const toStringArray = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : []

// useCookie keeps the raw JSON string in memory after a write (notably safari mobile), so guard the parse.
const parse = (value: string | string[] | null | undefined): string[] => {
  if (Array.isArray(value)) return toStringArray(value)
  if (!value) return []
  try {
    return toStringArray(JSON.parse(value))
  } catch {
    return []
  }
}

export function useRecentSearches() {
  const cookie = useCookie<string | string[] | null>(COOKIE_NAME)

  // initialised once from the cookie, then this composable is the sole writer
  const searches = useState<string[]>('recent-searches', () => parse(cookie.value))

  const persist = (list: string[]) => {
    searches.value = list
    cookie.value = JSON.stringify(list)
  }

  const add = (term: string) => persist([...new Set([term, ...searches.value])].slice(0, MAX_RECENT_SEARCHES))
  const remove = (term: string) => persist(searches.value.filter((t) => t !== term))
  const clear = () => persist([])

  return { searches: readonly(searches), add, remove, clear }
}
